var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", {
        attrs: { color: _vm.errorSubSection },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var open = ref.open
              return [
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "text--secondary", attrs: { cols: "12" } },
                      [
                        _c(
                          "v-fade-transition",
                          { attrs: { "leave-absolute": "" } },
                          [
                            open
                              ? _c(
                                  "v-row",
                                  { attrs: { dense: "" } },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "3" },
                                      },
                                      [
                                        _c("h3", [
                                          _vm._v(" Solutions Purchase "),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "v-row",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { dense: "" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "3" },
                                      },
                                      [
                                        _c("h4", [_vm._v(" Tipology: ")]),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.componentTipology || ""
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "3" },
                                      },
                                      [
                                        _c("h4", [
                                          _vm._v(" Proposal Amount: "),
                                        ]),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.FormatMoney(
                                                _vm.offerAmount || 0
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "3" },
                                      },
                                      [
                                        _c("h4", [_vm._v(" Cost: ")]),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.FormatMoney(
                                                _vm.expectedCost || 0
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { cols: "12", sm: "4", md: "3" },
                                      },
                                      [
                                        _c("h4", [_vm._v(" Margin: ")]),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.expectedMarginPerc + "%" || 0
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "v-expansion-panel-content",
        [
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4", lg: "3" } },
                [
                  _c("pga-select", {
                    attrs: {
                      items: _vm.businessLineDropdown,
                      label: "Business Lines",
                      "item-value": "Id",
                      "item-text": "Title",
                      clearable: "",
                      "key-error": "SolutionsPurchase.BusinessLineId",
                      errors: _vm.Errors,
                      readonly: _vm.restricted,
                    },
                    model: {
                      value: _vm.businessLine,
                      callback: function ($$v) {
                        _vm.businessLine = $$v
                      },
                      expression: "businessLine",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4", lg: "3" } },
                [
                  _c("pga-select", {
                    attrs: {
                      items: _vm.techAreaDropdown,
                      label: "Tech Area",
                      "item-value": "Id",
                      "item-text": "Name",
                      clearable: "",
                      "key-error": "SolutionsPurchase.TechAreaId",
                      errors: _vm.Errors,
                      readonly: _vm.restricted,
                    },
                    model: {
                      value: _vm.techArea,
                      callback: function ($$v) {
                        _vm.techArea = $$v
                      },
                      expression: "techArea",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "9", lg: "6" } },
                [
                  _c("pga-select", {
                    attrs: {
                      items: _vm.supplyTipologyDropdown,
                      label: "Supply Tipology",
                      "item-value": "Id",
                      "item-text": "Name",
                      clearable: "",
                      "key-error": "SolutionsPurchase.SupplyTipologyId",
                      errors: _vm.Errors,
                      readonly: _vm.restricted,
                    },
                    model: {
                      value: _vm.supplyTipology,
                      callback: function ($$v) {
                        _vm.supplyTipology = $$v
                      },
                      expression: "supplyTipology",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              !_vm.restricted
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "3" } },
                    [
                      _c("pga-dropdown-search", {
                        attrs: {
                          items: _vm.suppliersDropdown,
                          "item-text": "BusinessName",
                          label: "Supplier",
                          "show-menu": _vm.showDynamicDropdown,
                          "return-object": "",
                          loading: _vm.dropdownLoading,
                        },
                        on: {
                          click: function ($event) {
                            _vm.showDynamicDropdown = !_vm.showDynamicDropdown
                          },
                          "search-input": _vm.requestSuppliersDebounced,
                        },
                        model: {
                          value: _vm.supplier,
                          callback: function ($$v) {
                            _vm.supplier = $$v
                          },
                          expression: "supplier",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "3" } },
                [
                  _c("pga-text-field", {
                    attrs: {
                      label: "Supplier Code",
                      "key-error": "SolutionsPurchase.SupplierCode",
                      errors: _vm.Errors,
                      readonly: _vm.restricted,
                    },
                    model: {
                      value: _vm.supplierCode,
                      callback: function ($$v) {
                        _vm.supplierCode = $$v
                      },
                      expression: "supplierCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c("pga-text-field", {
                    attrs: {
                      label: "Supplier Business Name",
                      "key-error": "SolutionsPurchase.SupplierBusinessName",
                      errors: _vm.Errors,
                      readonly: _vm.restricted,
                    },
                    model: {
                      value: _vm.supplierBusinessName,
                      callback: function ($$v) {
                        _vm.supplierBusinessName = $$v
                      },
                      expression: "supplierBusinessName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c("pga-select", {
                    attrs: {
                      items: _vm.solutionCatalogDropdown,
                      label: "Solutions Catalog",
                      "item-value": "Id",
                      "item-text": "Description",
                      clearable: "",
                      "key-error": "SolutionsPurchase.SolutionCatalogId",
                      errors: _vm.Errors,
                      readonly: _vm.restricted,
                    },
                    model: {
                      value: _vm.solutionCatalog,
                      callback: function ($$v) {
                        _vm.solutionCatalog = $$v
                      },
                      expression: "solutionCatalog",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "3" } },
                [
                  _c("pga-text-field", {
                    attrs: {
                      label: "Description",
                      "key-error": "SolutionsPurchase.Description",
                      errors: _vm.Errors,
                      readonly: _vm.restricted,
                    },
                    model: {
                      value: _vm.description,
                      callback: function ($$v) {
                        _vm.description = $$v
                      },
                      expression: "description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "2" } },
                [
                  _c("pga-currency-field", {
                    attrs: {
                      label: "Proposal Amount",
                      "key-error": "SolutionsPurchase.OfferAmount",
                      errors: _vm.Errors,
                      readonly: _vm.restricted,
                    },
                    model: {
                      value: _vm.offerAmount,
                      callback: function ($$v) {
                        _vm.offerAmount = $$v
                      },
                      expression: "offerAmount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "2" } },
                [
                  _c("pga-currency-field", {
                    attrs: {
                      label: "Expected Cost",
                      "key-error": "SolutionsPurchase.ExpectedCost",
                      errors: _vm.Errors,
                      readonly: _vm.restricted,
                    },
                    model: {
                      value: _vm.expectedCost,
                      callback: function ($$v) {
                        _vm.expectedCost = $$v
                      },
                      expression: "expectedCost",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "4", md: "2" } },
                [
                  _c("pga-currency-field", {
                    attrs: { label: "Expected Margin", readonly: "" },
                    model: {
                      value: _vm.expectedMargin,
                      callback: function ($$v) {
                        _vm.expectedMargin = $$v
                      },
                      expression: "expectedMargin",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c("pga-text-field", {
                    attrs: {
                      prefix: "%",
                      label: "Expected Margin %",
                      readonly: "",
                    },
                    model: {
                      value: _vm.expectedMarginPerc,
                      callback: function ($$v) {
                        _vm.expectedMarginPerc = $$v
                      },
                      expression: "expectedMarginPerc",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }